import { getUserInfoCollection } from '@/api/user';

// 存储用户信息的全局对象
const userInfo = {};
// 存储所有组件需要的完整数据
const fullUserData = {};

// 数据类型映射配置
const DATA_TYPE_MAPPING = {
  'userInfo.basicInfo': 'basicInfo',
  'userInfo.identityInfo': 'identityInfo',
  'userInfo.locationInfo': 'locationInfo',
  'userInfo.usageRecord': 'usageRecords',
  'userInfo.additionalService': 'additionalService',
};

// 获取用户信息集合
const getInfoCollection = async (getUserData) => {
  const params = {
    params: { ...getUserData },
    code: 'usr_info_collection',
  };
  const { data } = await getUserInfoCollection(params);

  // 存储原始数据
  Object.assign(userInfo, data);

  // 处理组件数据
  if (data.componentData && data.componentData.userInfo) {
    const userData = data.componentData.userInfo;

    // 根据新的数据结构动态构成分发给各组件的数据
    Object.keys(DATA_TYPE_MAPPING).forEach((dataPath) => {
      const [, category] = dataPath.split('.');
      const componentName = DATA_TYPE_MAPPING[dataPath];

      if (userData[category]) {
        fullUserData[componentName] = {};

        // 遍历该分类下的所有数据项
        Object.keys(userData[category]).forEach((itemKey) => {
          const item = userData[category][itemKey];
          fullUserData[componentName][itemKey] = {
            collectBy: item.collectBy || '哈啰出行APP',
            name: item.name || itemKey,
            collectInfo: item.collectInfo || '-',
            infoContent: item.infoContent || '-',
            collectScene: item.collectScene || '',
            jumpUrl: item.jumpUrl || null,
          };
        });
      }
    });
  }

  return fullUserData;
};

// 获取特定组件的数据
const getComponentData = (componentName) => fullUserData[componentName] || {};

// 检查数据是否已加载
const isDataLoaded = () => Object.keys(fullUserData).length > 0;

export {
  getInfoCollection,
  getComponentData,
  isDataLoaded,
};
